import { baseColors } from './baseColors';
const fill = {
    background: baseColors.grayscale['0875'],
    subtle: baseColors.grayscale['0750'],
    strong: baseColors.grayscale['0000'],
    disabled: {
        subtle: baseColors.grayscale['0750'],
    },
    critical: {
        subtle: baseColors.red.darkest,
        strong: baseColors.red.light,
    },
    info: {
        subtle: baseColors.blue.darkest,
        strong: baseColors.blue.light,
    },
    caution: {
        subtle: baseColors.yellow.darker,
        strong: baseColors.yellow.lighter,
    },
    celebratory: {
        subtle: baseColors.green.darkest,
        strong: baseColors.green.lighter,
    },
};
const stroke = {
    neutral: {
        text: {
            highContrast: {
                on: {
                    background: baseColors.grayscale['0000'],
                    subtle: baseColors.grayscale['0000'],
                    strong: baseColors.grayscale['1000'],
                },
            },
            primary: {
                on: {
                    background: baseColors.grayscale['0000'],
                    subtle: baseColors.grayscale['0000'],
                    strong: baseColors.grayscale['0875'],
                },
            },
            secondary: {
                on: {
                    background: baseColors.grayscale['0250'],
                    subtle: baseColors.grayscale['0250'],
                    strong: baseColors.grayscale['0750'],
                },
            },
            tertiary: {
                on: {
                    background: baseColors.grayscale['0375'],
                    subtle: baseColors.grayscale['0375'],
                    strong: baseColors.grayscale['0625'],
                },
            },
        },
        border: {
            interaction: {
                primary: {
                    on: {
                        background: baseColors.grayscale['0000'],
                    },
                },
                secondary: {
                    on: {
                        background: baseColors.grayscale['0375'],
                    },
                },
                tertiary: {
                    on: {
                        background: baseColors.grayscale['0500'],
                    },
                },
            },
            decoration: {
                on: {
                    background: baseColors.grayscale['0625'],
                    subtle: baseColors.grayscale['0625'],
                    strong: baseColors.grayscale['0750'],
                },
            },
        },
    },
    focused: {
        outline: {
            on: {
                background: baseColors.blue.light,
                subtle: baseColors.blue.light,
            },
        },
    },
    critical: {
        text: {
            on: {
                background: baseColors.red.lighter,
                subtle: baseColors.red.lighter,
            },
        },
    },
    info: {
        text: {
            on: {
                background: baseColors.blue.light,
                subtle: baseColors.blue.light,
            },
        },
    },
    caution: {
        text: {
            on: {
                background: baseColors.yellow.lighter,
                subtle: baseColors.yellow.lighter,
            },
        },
    },
    celebratory: {
        text: {
            on: {
                background: baseColors.green.light,
                subtle: baseColors.green.light,
            },
            highContrast: {
                on: {
                    subtle: baseColors.green.lightest,
                },
            },
        },
    },
    disabled: {
        text: {
            on: {
                background: baseColors.grayscale['0375'],
                subtle: baseColors.grayscale['0250'],
            },
        },
    },
};
export const paletteColorsDarkMode = {
    fill,
    stroke,
};
//# sourceMappingURL=paletteColorsDarkMode.js.map